import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useWalletValue } from '@frontend/hooks/useWalletValue';
import { useCoinPriceContext } from '@frontend/providers/CoinPriceProvider';
import { usePlatform } from '@frontend/providers/PlatformProvider';
import getNodeUrl from '@frontend/utils/rpcRandom';
import { chainData } from '@jdiyield/constants';
import { getJDIAutoData, getJDIVaultAPR } from '@jdiyield/contracts';
import { Chain, PlatformName } from '@jdiyield/interfaces';
import { useWeb3React } from '@web3-react/core';
import { createContext, useContext } from 'react';
import Web3 from 'web3';
var initialState = {
  loading: false,
  thisChain: 'bsc',
  vaultResult: [],
  tvlSummary: 0
};
var VaultContext = /*#__PURE__*/createContext(_objectSpread(_objectSpread({}, initialState), {}, {
  refetch: function refetch() {
    return null;
  }
}));
export var useVaultContext = function useVaultContext() {
  return useContext(VaultContext);
};
export var VaultProvider = function VaultProvider(_ref) {
  var children = _ref.children;

  var _usePlatform = usePlatform(),
      tokens = _usePlatform.tokens;

  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account,
      chainId = _useWeb3React.chainId,
      library = _useWeb3React.library;

  var _useCoinPriceContext = useCoinPriceContext(),
      coinList = _useCoinPriceContext.coinList;

  var _useWalletValue = useWalletValue(initialState, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(setValue) {
      var _chainData$chainID;

      var chainID, ChainName, poolResult;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              chainID = [56, 137].includes(chainId) ? chainId : 56;
              setValue(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  loading: prev.thisChain === chainID ? false : true
                });
              });
              ChainName = (_chainData$chainID = chainData[chainID]) === null || _chainData$chainID === void 0 ? void 0 : _chainData$chainID.chainName;

              if (!(Object.keys(coinList).length > 0)) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return getJDIAutoData(account ? library : new Web3(getNodeUrl(chainID)), ChainName, account, tokens, coinList);

            case 6:
              poolResult = _context.sent;
              setValue(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  vaultResult: poolResult,
                  loading: false,
                  thisChain: chainID,
                  tvlSummary: 0
                });
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [account, chainId, coinList]),
      _useWalletValue2 = _slicedToArray(_useWalletValue, 2),
      _useWalletValue2$ = _useWalletValue2[0],
      vaultResult = _useWalletValue2$.vaultResult,
      loading = _useWalletValue2$.loading,
      thisChain = _useWalletValue2$.thisChain,
      refetch = _useWalletValue2[1].refetch;

  var _useWalletValue3 = useWalletValue(initialState, /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(setValue) {
      var _chainData$chainId, ChainName, platformName, vaultPromise, result, _result$reduce, vaultMapping, totalTVL;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              setValue(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  tvlSummary: 0
                });
              });
              ChainName = (_chainData$chainId = chainData[chainId]) === null || _chainData$chainId === void 0 ? void 0 : _chainData$chainId.chainName;
              platformName = ChainName === Chain.POLYGON ? PlatformName.JDI_POLYGON : PlatformName.JDI;

              if (!(Object.keys(coinList).length > 0)) {
                _context3.next = 11;
                break;
              }

              vaultPromise = vaultResult.map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(vault) {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          return _context2.abrupt("return", Promise.all(vault === null || vault === void 0 ? void 0 : vault.data.map(function (item) {
                            var _Object$values$find;

                            var balanceLP = item.data.balanceLP;
                            var chainID = (_Object$values$find = Object.values(chainData).find(function (_ref5) {
                              var chainName = _ref5.chainName;
                              return chainName === vault.chain;
                            })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.chainID;
                            return getJDIVaultAPR(platformName, balanceLP, item, chainID, tokens, coinList);
                          })));

                        case 1:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());
              _context3.next = 8;
              return Promise.allSettled(vaultPromise);

            case 8:
              result = _context3.sent;
              _result$reduce = result.reduce(function (acc, cur, index) {
                var aprPlatforms = cur.value;
                var totalCount = aprPlatforms.reduce(function (count, current) {
                  return count += current.vaultTvlUSD || 0;
                }, 0);
                vaultResult[index].data = vaultResult[index].data.map(function (o, i) {
                  return _objectSpread(_objectSpread({}, o), {}, {
                    aprData: aprPlatforms[i]
                  });
                });
                acc.vaultMapping[index] = vaultResult[index];
                acc.totalTVL += totalCount;
                setValue(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    tvlSummary: acc.totalTVL
                  });
                });
                return {
                  vaultMapping: acc.vaultMapping,
                  totalTVL: acc.totalTVL
                };
              }, {
                vaultMapping: [],
                totalTVL: 0
              }), vaultMapping = _result$reduce.vaultMapping, totalTVL = _result$reduce.totalTVL;
              setValue(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  tvlSummary: totalTVL,
                  vaultResult: vaultMapping
                });
              });

            case 11:
              _context3.next = 16;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](0);
              console.log('fetchAPR', _context3.t0);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 13]]);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [vaultResult, coinList]),
      _useWalletValue4 = _slicedToArray(_useWalletValue3, 1),
      tvlSummary = _useWalletValue4[0].tvlSummary;

  var handleRefetch = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (loading) {
                _context4.next = 3;
                break;
              }

              _context4.next = 3;
              return refetch();

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleRefetch() {
      return _ref6.apply(this, arguments);
    };
  }();

  return _jsx(VaultContext.Provider, {
    value: {
      vaultResult: vaultResult,
      tvlSummary: tvlSummary,
      thisChain: thisChain,
      loading: loading,
      refetch: handleRefetch
    },
    children: children
  });
};